import * as React from 'react';
import {
  UserLocationInfo,
  setLastUsedPosition,
  getLastUsedPosition,
  ExpireablePosition,
  getLatLong,
} from '@packages/common';
import { AlgoliaContext, ZipCodeSearchParam } from '@packages/services';

interface UserLocation {
  position: ExpireablePosition | null;
  updateUserLocation: (zipCode?: string) => Promise<UserLocationInfo>;
  locationSearchError: boolean;
}

export function useUserLocation(): UserLocation {
  const { zipCodeSearch } = React.useContext(AlgoliaContext);
  const [locationSearchError, setLocationSearchError] = React.useState(false);
  const [lastPosition, setLastPosition] = React.useState<ExpireablePosition | null>(getLastUsedPosition());

  // TODO: check do we need this
  const setPosition = (position: UserLocationInfo | null) => {
    const userLocation = setLastUsedPosition(position);
    setLastPosition(userLocation);
  };

  const updateUserLocation = React.useMemo(() => {
    return async (zipCode?: string) => {
      setLocationSearchError(false);
      const params: ZipCodeSearchParam = zipCode || (await getLatLong());
      return zipCodeSearch(params)
        .then((data) => {
          const firstHit = data?.hits?.[0];
          if (firstHit) {
            const { city, zip, _geoloc } = firstHit;
            const positionData = {
              city,
              zipCode: zip,
              coords: _geoloc,
            };

            setPosition(positionData);
            return positionData;
          } else {
            setLocationSearchError(true);
            return undefined;
          }
        })
        .catch(() => {
          setLocationSearchError(true);
          return undefined;
        });
    };
  }, [zipCodeSearch]);

  return { position: lastPosition, updateUserLocation, locationSearchError };
}
